import { gql } from '@apollo/client';
const REMOVE_PRODUCT = gql `
  mutation RemoveProduct($productId: ID!) {
    removeProduct(productId: $productId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT;
